import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { ILoginResponse, IResponse } from '@interfaces/index';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  
  form: FormGroup;
  loading = false;
  token: string | null = null;

  constructor(
    protected _fb: FormBuilder,
    protected _app_service: AppService,
    protected _router: Router,
    protected _auth_service: AuthService,
    protected _route: ActivatedRoute
  ) {
    this.form = this._fb.group({
      password: [null, Validators.required]
    })
  }

  ngOnInit() {
    this._route.params.subscribe(
      (params: Params) => {
        this.token = params['token'];
      }
    )
  }

  login() {
    if (this.form.valid) {
      this.setLoadingState(true);
      this._auth_service.resetPassword(this.form.get('password')?.value, this.token as string).subscribe(
        (response: IResponse<ILoginResponse>) => this._app_service.handleLoginResponse(response),
        () => this._app_service.handleLoginError()
      );
    }
  }

  setLoadingState(state: boolean) {
    this.loading = state;
  }
  
}
